import { render, staticRenderFns } from "./SettingsRoute.vue?vue&type=template&id=063b091c&scoped=true"
import script from "./SettingsRoute.vue?vue&type=script&lang=ts"
export * from "./SettingsRoute.vue?vue&type=script&lang=ts"
import style0 from "./SettingsRoute.vue?vue&type=style&index=0&id=063b091c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063b091c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('063b091c')) {
      api.createRecord('063b091c', component.options)
    } else {
      api.reload('063b091c', component.options)
    }
    module.hot.accept("./SettingsRoute.vue?vue&type=template&id=063b091c&scoped=true", function () {
      api.rerender('063b091c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SettingsRoute.vue"
export default component.exports